// Generates or retrieves stable, privacy-conscious identifiers for attribution.
// These are not tied to PII without explicit user consent.

export const getVisitorId = () => {
  if (typeof window === 'undefined') return null;
  let vid = localStorage.getItem('meetoi_vid');
  if (!vid) {
    vid = 'v_' + Math.random().toString(36).substr(2, 9) + Date.now().toString(36);
    localStorage.setItem('meetoi_vid', vid);
  }
  return vid;
};

export const getSessionId = () => {
  if (typeof window === 'undefined') return null;
  let sid = sessionStorage.getItem('meetoi_sid');
  if (!sid) {
    sid = 's_' + Math.random().toString(36).substr(2, 9) + Date.now().toString(36);
    sessionStorage.setItem('meetoi_sid', sid);
  }
  return sid;
};